module.exports = __webpack_public_path__ + "img/img_futa_elegant.ce1e01a0.png";